import { useFeatureFlagStore } from '@moniebook-web/store';
import { FEATURE_FLAG_PREFIX } from '@moniebook-web/utils';
import { useRegisterConfiguration } from '@register-ui/utils';
import { useFlags } from '@unleash/proxy-client-react';
import { useEffect } from 'react';

export function LoadAllFeatureFlags() {
    const { setFeatureFlags } = useFeatureFlagStore();
    const flags = useFlags();

    const { config } = useRegisterConfiguration();

    useEffect(() => {
        if (flags.length === 0) return;

        const flagsTable = flags
            .filter((flag) => flag.name.startsWith(FEATURE_FLAG_PREFIX))
            .reduce((acc: Record<string, boolean>, flag) => {
                acc[flag.name] = flag.enabled;
                return acc;
            }, {});

        setFeatureFlags(flagsTable);
    }, [flags, setFeatureFlags, config.businessId]);

    return null;
}
